<template>
  <div class="container mt-3">
    <div class="card announcement border-primary shadow-sm">
      <div class="card-header announcement-header" @click="toggle">
        <h6 class="card-title text-primary mb-0 announcement-title">
          <i class="fas fa-bullhorn mr-2"></i>
          Nova versão da Calculadora de Prazos já disponível!
        </h6>
        <button type="button" class="btn btn-sm btn-outline-primary toggle-btn" @click.stop="toggle">
          <span v-if="collapsed"><i class="fas fa-chevron-down mr-1"></i>Abrir</span>
          <span v-else><i class="fas fa-chevron-up mr-1"></i>Minimizar</span>
        </button>
      </div>

      <div v-show="!collapsed" class="card-body announcement-body">
        <p class="mb-2">Caros Colegas e Clientes,</p>

        <p class="mb-2">
          Temos o prazer de anunciar a nova versão da nossa Calculadora de Prazos
          Processuais, com mais funcionalidades e uma experiência renovada.
        </p>

        <p class="mb-3">
          <a href="https://v2.4lawyers.pt/prazos" target="_blank" rel="noopener"
             class="btn btn-primary">
            Experimentar a nova versão <i class="fas fa-external-link-alt ml-1"></i>
          </a>
        </p>

        <p class="mb-2">
          Convidamo-los a experimentá-la e a partilhar o vosso feedback e sugestões.
          Manteremos a versão atual disponível durante os próximos meses, mas o nosso
          objetivo é migrar gradualmente para a nova versão.
        </p>

        <p class="mb-0 text-muted">
          É a mesma equipa de sempre &mdash; continuamos apenas a desenvolver e a
          acrescentar novas funcionalidades a um projeto que já conta com a vossa
          confiança. E, como sempre, a ferramenta manter-se-á totalmente gratuita.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Announcement',
  data() {
    return {
      collapsed: false
    }
  },
  created() {
    if (localStorage.getItem('announcement_v2_collapsed') === '1') {
      this.collapsed = true
    }
  },
  methods: {
    toggle() {
      this.collapsed = !this.collapsed
      localStorage.setItem('announcement_v2_collapsed', this.collapsed ? '1' : '0')
    }
  }
}
</script>

<style scoped>
.announcement {
  border-width: 2px;
}
.announcement-header {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(0, 123, 255, 0.05);
}
.toggle-btn {
  margin-left: 1rem;
  white-space: nowrap;
  font-size: 0.8rem;
}
.announcement-title {
  font-size: 0.95rem;
}
.announcement-body {
  font-size: 0.85rem;
}
.announcement-body .btn {
  font-size: 0.85rem;
}
</style>
